export function getARIAProps<A extends Record<string, any>>(
  props: A
): Partial<A> {
  const ariaProps = {};
  for (const [propName, propValue] of Object.entries(props)) {
    if (propName.startsWith("aria-")) {
      ariaProps[propName] = propValue;
    }
  }
  return ariaProps;
}
